import { useQuery } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';

import { RENTAL_MANAGER_API_V1_PREFIX } from '../../constants/RouteConstants';
import TimeConstants from '../../constants/TimeConstants';
import makeRequest from '../../utils/makeRequestUtils';
import useRequestConfig from '../../hooks/useRequestConfig';

export const useGetInterestedRenters = (
  { listingAlias = '', clientTimeZone = 'America/New_York', folder = 'inbox', limit = 3 },
  queryOptions = {},
) => {
  const dispatch = useDispatch();
  const requestConfig = useRequestConfig();

  const queryFn = () =>
    makeRequest({
      dispatch,
      endpoint: `${RENTAL_MANAGER_API_V1_PREFIX}/users/listingConversation/leadManagement/leadManagementTable`,
      requestConfig,
      config: {
        params: { listingAlias, clientTimeZone, folder, limit },
      },
    });

  return useQuery({
    queryKey: ['getInterestedRenters', limit, listingAlias],
    queryFn: async () => {
      const data = await queryFn();

      return data;
    },
    ...queryOptions,
    enabled: Boolean(listingAlias),
    staleTime: TimeConstants.SECONDS_10,
  });
};
